import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CommonService } from '../../../services/common.service';
import { Navigation, NavigationChild } from '../../../model/user';

@Injectable({ providedIn: 'root' })
export class CanAccessPageGuard implements CanActivate {
  constructor(public router: Router, public cService: CommonService) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let canActivate = true;

    return this.cService.navigationReady$.toPromise().then(() => {
      if (this.cService.navigation.length > 0 && state.url) {
        const triggeredNav: Navigation = this.getNavigatedItem(state.url, this.cService.navigation);

        if (triggeredNav) {
          if (triggeredNav.hidden || triggeredNav.disabled) {
            canActivate = false;
          }
        } else {
          // Check if a child was navigated
          for (let i = 0; i < this.cService.navigation.length; i++) {
            const parentNav = this.cService.navigation[i];

            if (parentNav.children) {
              const triggeredNavChild: NavigationChild = this.getNavigatedItem(state.url, parentNav.children);

              if (triggeredNavChild) {
                if (triggeredNavChild.hidden || parentNav.hidden || parentNav.disabled) {
                  canActivate = false;
                }

                break;
              }
            }
          }
        }
      }

      return canActivate;
    });
  }

  private getNavigatedItem(
    stateUrl: string,
    navigationList: Array<Navigation | NavigationChild>
  ): Navigation | NavigationChild {
    let navigated: Navigation | NavigationChild = null;

    for (let i = 0; i < navigationList.length; i++) {
      const nav = navigationList[i];
      if (nav.url && nav.url.trim().replace('#', '').toLowerCase() === stateUrl.trim().toLowerCase()) {
        navigated = nav;
        break;
      }
    }

    return navigated;
  }
}
